module.exports = __webpack_public_path__ + "img/First_image_.0459f95c.svg";